module.exports = __webpack_public_path__ + "img/item.52bc9cf9.svg";